<div class="notificacao-sino-wrapper d-inline-block">
  <button class="btn btn-link position-relative p-1"
          [matMenuTriggerFor]="menuNotificacoes"
          (menuOpened)="abrirPainel()"
          (menuClosed)="fecharPainel()">
    <mat-icon class="icon-sino">notifications</mat-icon>
    <span class="badge-contador">
      {{ contador > 99 ? '99+' : contador }}
    </span>
  </button>

  <mat-menu #menuNotificacoes="matMenu" class="notificacao-menu" xPosition="before">
    <div class="notificacao-painel" (click)="$event.stopPropagation()">
      <div class="notificacao-header">
        <span class="fw-bold">Notificações</span>
        <span class="badge bg-primary ms-2" *ngIf="contador > 0">{{ contador }}</span>
      </div>

      <div class="notificacao-lista" *ngIf="notificacoes.length > 0">
        <div class="notificacao-item"
             *ngFor="let notif of notificacoes"
             (click)="abrirNotificacao(notif)"
             [class.clicavel]="possuiRedirecionamento(notif)"
             [style.cursor]="possuiRedirecionamento(notif) ? 'pointer' : 'default'">
          <div class="d-flex align-items-start">
            <div class="notificacao-icone me-2">
              <mat-icon class="text-primary" style="font-size: 20px; width: 20px; height: 20px;">info</mat-icon>
            </div>
            <div class="flex-grow-1">
              <span class="notificacao-credor">{{ notif.credor }}</span>
              <small class="notificacao-documento text-muted ms-2">- {{ formatarDocumento(notif.documentoCredor) }}</small>
              <p class="notificacao-mensagem mb-1">{{ notif.mensagem }}</p>
              <small class="notificacao-data text-muted">
                {{ notif.dataCriacao | date:'dd/MM/yyyy HH:mm' }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="notificacao-vazio text-center py-4" *ngIf="notificacoes.length === 0">
        <mat-icon class="text-muted mb-2" style="font-size: 36px; width: 36px; height: 36px;">notifications_off</mat-icon>
        <p class="text-muted mb-0" style="font-size: 14px;">Nenhuma notificação no momento.</p>
      </div>
    </div>
  </mat-menu>
</div>

